<template>
  <section>
    <el-table
      ref="table"
      :data="tableData"
      style="width: 100%"
      highlight-current-row
      :header-row-class-name="'tableHeader'"
      :row-style="rowClass"
      @selection-change="handleSelectionChange"
      @row-click="rowClick">
      <el-table-column
        v-if="!isSme&&!isEnquiry"
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="id"
        width="40"
      >
        <template #default="{ row }">
          <div class="flex-algin  flex-align-center">
            <span
              v-if="row.merchant_platform"
              class="table-icon__img">
              <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
            </span>
            <span>
              <font-awesome-icon :icon="isEnquiry?'comment-alt':'ticket-alt'"></font-awesome-icon>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column   width="145">
        <template #default="{ row }">
          <div class="flex-algin">
            <p> <span class="span-status type-status">{{ isEnquiry?row.enquiry_type_language:row.type_language }}</span></p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Subject"
        :show-overflow-tooltip="true"
        min-width="230">
        <template #default="{ row }">
          <div
            class="flex-algin"
            @click="rowClick(row)">
            <div class="flex flex-circle">
              <div
                class="blue-circle"
                :class="{'yellow-circle':row.is_snooze === 1,'blue':row.client_updated==1}"
                @click.stop="handlerBluePoint(row.id)">
              </div>
              <router-link
                class="showLick"
                :to="rowClickFn(row)">
                {{ row.subject }}
              </router-link>
            </div>
            <p class="liter-text">{{ isEnquiry?row.enquiry_no:row.ticket_number }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isEnquiry"
        label="Remark"
        :show-overflow-tooltip="true"
        min-width="230">
        <template #default="{ row }">
          <div
            class="flex-algin">
            <span
              v-for="(item,index) in row.remark_list"
              :key="index"
              class="liter-text fw-400 fs-12 block"
              v-html="changeLineText(item.message)"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isEnquiry"
        min-width="180"
        label="Policy">
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <div
            >
              <span class="span-label fw-600 color-dark fs-14">{{ row.insurer }} {{  80>row.class_id>50?row.product_type:row.plan}}</span>
            </div>
            <p
              v-if="row.pcy_no||row.cvr_nt_no"
              class="phone-text">
              <span
                v-if="row.pcy_no "
                class="block"><span class=" fw-600">Policy No. </span> {{ row.pcy_no }}</span>
            </p>
            <span
              v-if="row.order_sn"
              class="phone-text">
              <template><span class=" fw-600">Ref. </span>{{ row.order_sn }}</template>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        label="Agency">
        <template #default="{ row }">
          <div
            class="flex-algin"
            :class="{'height-36':isEnquiry}">
            <span
              v-if="isEnquiry"
              @click.stop="handleEnquiryMessage(row.id)"
            >
              <span  class="header-icon block">
                <img
                  v-if="row.agency_icon"
                  :src="row.agency_icon">
              </span>
            </span>
            <span
              v-else
              class="first-text">{{ row.agency_nickname }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="requester"
        :show-overflow-tooltip="true"
        label="Requester">
        <template #default="{ row }">
          <div class="flex flex-align-center">
            <div
              v-if="isEnquiry"
              class="enquiry-icon-box"
              @click.stop="handleEnquiryMessage(row.id)">
              <font-awesome-icon
                class="enquiry-icon "
                :class="{'yellow':row.unread>0}"
                icon="comment-alt"></font-awesome-icon>
              <span
                v-if="row.unread>0"
                class="right-dot">
                <div class="flex flex-circle">
                  <div
                    class="blue-circle green"
                  >
                  </div>
                </div>
              </span>
            </div>
            <div class="flex-algin">
              <span class="text-span">{{ isEnquiry?row.name:row.requester }}</span>
              <p class="liter-text">{{row.phone?row.phone:''}}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="assignee"
        label="Assigned">
        <template #default="{ row }">
          <div class="flex-algin">
            <span class="text-span">{{ row.assignee }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Status & Stage"
        width="160px">
        <template #default="{ row }">
          <div class="flex-algin">
            <div>
              <i
                class="status-height"
                :class="{
                  'status-one':row.status==1,
                  'status-two':row.status==2,
                  'status-three':row.status==3,
                  'status-red':row.status==5||row.status==4,
                }">{{ row.status_language }}</i>
            </div>
            <p>
              <i
                v-if="row.stts_language"
                class="span-status-stts"
                :class="{
                  'orange-light': [5].includes(row.stts)&&row.type==9||[1, 3,5].includes(row.stts)&&row.type==2||row.type==3&&[101,301].includes(row.stts),
                  'yellow-dark':[3].includes(row.stts)&&row.type==9||[0].includes(row.stts)&&row.type==2||row.type==4&&[1].includes(row.stts)||isSme&&[201].includes(row.stts)||(row.type==5||row.type==6||row.type==3)&&[0].includes(row.stts),
                  'blue': [2].includes(row.stts)&&row.type==9||[2,4].includes(row.stts)&&row.type==2||row.type==4&&[4].includes(row.stts)||row.type==3&&[201,501].includes(row.stts)||row.type==6&&[1].includes(row.stts)||isSme&&![201].includes(row.stts),
                  'green': [7].includes(row.stts)&&row.type==9||[6].includes(row.stts)&&row.type==2||row.type==4&&[2].includes(row.stts)||row.type==3&&[601].includes(row.stts)||row.type==5&&[1].includes(row.stts)||row.type==6&&[3].includes(row.stts),
                  'red': [4,6].includes(row.stts)&&row.type==9||[4].includes(row.stts)&&row.type==6||[6].includes(row.stts)&&row.type==3||row.type==4&&[3].includes(row.stts)||row.type==3&&[401].includes(row.stts),
                  'purple': [2].includes(row.stts)&&row.type==6,
                  'gray': [1].includes(row.stts)&&row.type==9,
                }">{{ row.stts_language }}</i>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        width="160"
        label="Created">
        <template #default="{ row }">
          <span class="liter-time">{{ row.created_at.split(" ")[0] }}</span><br>
          <span class="liter-time"> {{ row.created_at.split(" ")[1] }}</span>
        </template>
      </el-table-column>


    </el-table>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'ListTable',
  mixins: [MixinOptions],
  props:{
    tableData:{
      type: Array,
      default: () => []
    },
    isSme:{
      type:Boolean,
      default:false
    },
    isEnquiry:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      selectionTickets: [],
      selectRow:[],
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('selectionChange',val)
    },

    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(row.id)) {
        return { 'background-color':' rgb(241,248,255)' }
      }
    },

    rowClick(row) {
      this.$emit('rowClick',row)
    },
    handlerBluePoint(id){
      this.$emit('point',id)
    },
    handleEnquiryMessage(id){
      this.$router.push({
        path:'/enquiry/detail',
        query:{
          id: id,
          tab:4
        }
      })
    },
    // 新标签打开链接
    rowClickFn(row){
      let path = '/tickets/detail'
      if(this.isSme){
        path =`/sme${path}`
      }
      if(this.isEnquiry)
      {
        path ='/enquiry/detail'
        return({
          path: path,
          query: {
            id: row.id
          }
        })
      }else
        return({
          path: path,
          query: {
            ticket_id: row.id
          }
        })
    },
  },
}
</script>
<style lang='scss' scoped>
.transparent {
  margin-top: 15px;
}
.blue-circle {
  position: relative;
  display: inline-block;
  margin-right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  cursor: pointer;
  position: absolute;
  left: -5px;
  &.blue{
    background: #409EFF;
  }
  &.yellow-circle{
    background: #DBAB09!important;
  }
  &::after {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
  }
}
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    height: 45px;
    th {
      background-color:#F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      color: #24292E;
      height: 45px;
      .cell{
        height: 30px;
      }
    }
  }
  .span-status {
    margin-right: 5px;
    padding: 0 8px;
    border-radius: 25px;
    white-space: nowrap;

    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    &.success {
      color:  rgb(67, 181, 92);
      background: rgb(220, 255, 228);
    }
    &.warning {
      background: rgb(255, 245, 177);
      color: rgb(218, 193, 93);
    }
    &.error {
      background: rgb(215, 58, 73);
      color: white;
    }
    &.warning-plain {
      border: 1px solid #B08800;
      color: #B08800;
    }
    &.unread-uplod {
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.type-status{
      border: 1px solid #E1E4E8;
      color: #24292E;
    }
  }
  .status-height{
    height: 18px;
    line-height: 18px;
    padding: 0px 10px;
  }
  .status-two{
    border: 1px solid #0366D6;
    color: #0366D6;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
.status-red{
    border: 1px solid #F56C6D;
    color: #F56C6D;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
.status-yellow{
    border: 1px solid #DBAB09;
    color: #DBAB09;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .status-one{
    border: 1px solid #735C0F;
    color: #735C0F;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
  }
  .status-three
  {
    border: 1px solid #22863A;
    color: #22863A;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
  }
  .span-status-stts{
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: inline-block;
    color: #FFFFFF;
    padding: 0px 8px;
    height: 18px;

    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }
    &.gray {
      background: rgba(106, 115, 125, 1);
    }

  }
  .flex-aglin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    //height: 18px;
  }

.text-right{
  position: absolute;
  z-index: 100;
  right: 1px;
  margin-top: 6px;
  height: 40px;
  width: 90%;
  background-color:#F6F8FA !important;
}
.el-table{
  border-radius: 4px;
  border:1px solid #D1D5DA;
  ::v-deep .flex-algin{
    p,span{
      //height: 24px;
    }
    .flex-circle{
      height: 24px;
      align-items: center;
      span{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
      span{
        font-weight: 600;
      }
    }
  }
  .liter-time{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #24292E;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text-span{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
  ::v-deep .el-table-column--selection{
    .cell{
      padding-left: 15px!important;
    }
  }
  ::v-deep td{
    padding: 10px 0!important;
    vertical-align: top;
  }
  ::v-deep .el-checkbox:last-of-type{
    margin-top: 4px;
  }
}
::v-deep .el-date-editor{
  width: 200px!important;
}
.showLick{
  color:  #000;
  text-decoration: none;
  &:hover{
    color:  #0366D6;
  }
}
.flex-algin {
  display: flex;
  flex-direction: column;
}
.height-36{
  span{
    height: 36px!important;
  }
}
.header-icon{
  height: 36px!important;
  width: 36px;
  border-radius: 25px;
  border:1px solid #CCD4E0;
  display: block;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content:center;
  cursor: pointer;
  img{
    width: 36px;
  }

}
///deep/.el-table .cell{
//  overflow: auto!important;
//}
.enquiry-icon-box{
  position: relative;
  height: 18px;
  width: 18px;
  margin-right: 8px;
  .enquiry-icon{
    font-size: 18px;
    color: #D1D5DA;
    cursor: pointer;
    &.yellow{
      color: #FFD33D;
    }
  }
  .right-dot{
    position: absolute;
    right: 0;
    top: -2px;
    .green{
      background: #28A745;
    }
  }
}
.span-label {
  display: block;
  color: #24292E;
  font-weight: 600;
  word-break: break-word;
  font-size: 14px;
  text-decoration: none;
}
.font-nomarl{
  font-weight: 400!important;
}
</style>
